import { render, staticRenderFns } from "./PositionsSearch.vue?vue&type=template&id=0127bad4&scoped=true"
import script from "./PositionsSearch.js?vue&type=script&lang=js&external"
export * from "./PositionsSearch.js?vue&type=script&lang=js&external"
import style0 from "./PositionsSearch.scss?vue&type=style&index=0&id=0127bad4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0127bad4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default})
